<template>
  <div class="introduction">
    <div class="slogn">
      {{ dataSource.slogn.value }}
    </div>
    <div class="info">
      <div class="item">
        <div class="label">
          {{ dataSource.nl.label.value }}
        </div>
        <div class="value">
          {{ dataSource.nl.desc.value }}
        </div>
      </div>
      <div class="item">
        <div class="label">
          {{ dataSource.sg.label.value }}
        </div>
        <div class="value">
          {{ dataSource.sg.desc.value }}
        </div>
      </div>
      <div class="item">
        <div class="label">
          {{ dataSource.sr.label.value }}
        </div>
        <div class="value">
          {{ dataSource.sr.desc.value }}
        </div>
      </div>
      <div class="item">
        <div class="label">
          {{ dataSource.sszw.label.value }}
        </div>
        <div class="value">
          {{ dataSource.sszw.desc.value }}
        </div>
      </div>
      <div class="item">
        <div class="label">
          {{ dataSource.xq.label.value }}
        </div>
        <div class="value">
          {{ dataSource.xq.desc.value }}
        </div>
      </div>
      <div class="item">
        <div class="label">
          {{ dataSource.xhddx.label.value }}
        </div>
        <div class="value">
          {{ dataSource.xhddx.desc.value }}
        </div>
      </div>
      <div class="item">
        <div class="label">
          {{ dataSource.tyddx.label.value }}
        </div>
        <div class="value">
          {{ dataSource.tyddx.desc.value }}
        </div>
      </div>
      <div class="item">
        <div class="label">
          {{ dataSource.zxddx.label.value }}
        </div>
        <div class="value">
          {{ dataSource.zxddx.desc.value }}
        </div>
      </div>
    </div>
    <div class="info-1">
      <div class="item">
        <div class="label">
          {{ dataSource.cw1.label.value }}
        </div>
        <div class="value">
          {{ dataSource.cw1.desc.value }}
        </div>
      </div>
      <div class="item">
        <div class="label">
          {{ dataSource.cw2.label.value }}
        </div>
        <div class="value">
          {{ dataSource.cw2.desc.value }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="less" scoped>
.introduction {
  position: relative;
  width: 100%;
  overflow: hidden;
  padding-top: 60px;
  .slogn {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 15px;
    color: #b1b1b1;
    line-height: 22px;
    margin-bottom: 37px;
    padding: 0 4px;
  }

  .info {
    width: 100%;
    padding: 0 0 73px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px 10px;
  }
  .info-1 {
    width: 100%;
    .item {
      margin-bottom: 34px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .item {
    width: 100%;
    // margin-bottom: 14px;
    display: flex;
    align-items: flex-start;
    &:last-child {
      margin-bottom: 0px;
    }
    .label {
      flex-shrink: 0;
      width: 95px;
      height: 24px;
      background: rgba(201, 233, 255, 0.06);
      border-radius: 2px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 15px;
      color: rgba(102, 200, 237, 0.9);
      padding: 0 9px;
      line-height: 24px;
      margin-right: 10px;
    }

    .value {
      flex: 1;
      min-height: 24px;
      display: flex;
      align-items: center;
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      line-height: 22px;
    }
  }

  .other-info {
    width: 100%;
    .title {
      font-weight: 500;
      font-size: 13px;
      color: #f4f4f4;
      line-height: 15px;
      &::before {
        content: "";
        display: inline-block;
        width: 3px;
        height: 15px;
        background: linear-gradient(180deg, #497fc1 0%, #223c5b 100%);
        border-radius: 2px 2px 2px 2px;
        margin-right: 9px;
        vertical-align: middle;
      }
    }

    .content {
      padding: 18px 0 26px;
      .item {
        display: flex;
        gap: 3px;
        font-weight: 400;
        font-size: 12px;
        color: #c6c6c6;
        line-height: 14px;
        margin-bottom: 18px;
        &:last-child {
          margin-bottom: 0px;
        }

        .label {
          flex-shrink: 0;
        }
        .value {
          flex: 1;
        }
      }
    }
  }

  .show-more {
    position: absolute;
    bottom: 0px;
    left: 0;
    width: 100%;
    padding: 0 0 9px;
    text-align: center;
    img {
      width: 12px;
      height: 12px;
    }
  }
}
</style>
